import React from 'react';
import { motion } from 'framer-motion';
import './Consultation.css';

const Consultation = () => {
  return (
    <section className="legal-consultation-section">
      <div className="legal-container">
        {/* Header Section */}
        <div className="legal-header">
          <span className="legal-badge">Book A Consultation</span>
          <h2 className="legal-title">Your a <span className="gold-text">Consultation</span></h2>
          <p className="legal-subtitle">
            Get expert legal advice tailored to your needs. Fill out the form below and we'll get back to you within 24 hours.
          </p>
        </div>

        <div className="legal-consultation-grid">
          {/* Left Column: Contact Info & Expectations */}
          <div className="legal-sidebar">
            <motion.div 
              className="info-card"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h3>Contact Information</h3>
              <div className="contact-item">
                <label>Phone</label>
                <p className="gold-text">+91 9089876543</p>
              </div>
              <div className="contact-item">
                <label>Email</label>
                <p className="gold-text">contact@xyz</p>
              </div>
              <div className="contact-item">
                <label>Office Hours</label>
                <p>Monday - Friday</p>
                <p className="small-text">09:00Am - 06:00Pm</p>
                <p>Saturday</p>
                <p className="small-text">09:00Am - 02:00 Pm</p>
              </div>
            </motion.div>

            <motion.div 
              className="expectations-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h3>📄 What to Expect</h3>
              <ul>
                <li><span className="check">✔</span> Free initial consultation</li>
                <li><span className="check">✔</span> Confidential discussion</li>
                <li><span className="check">✔</span> Expert legal advice</li>
                <li><span className="check">✔</span> Clear next steps</li>
              </ul>
            </motion.div>
          </div>

          {/* Right Column: Personal Information Form */}
          <motion.div 
            className="legal-form-container"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <form className="legal-form">
              <h3>Personal information</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>Full name<span className="required">*</span></label>
                  <input type="text" placeholder="Exp. John Carter" required />
                </div>
                <div className="form-group">
                  <label>Email<span className="required">*</span></label>
                  <input type="email" placeholder="Enter your email" required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone number<span className="required">*</span></label>
                  <input type="tel" placeholder="(123) 000-0000" required />
                </div>
                <div className="form-group">
                  <label>Date</label>
                  <input type="date" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Time<span className="required">*</span></label>
                  <input type="text" placeholder="(123) 000-0000" required />
                </div>
                <div className="form-group">
                  <label>Case type</label>
                  <select>
                    <option>Select the type of case</option>
                    <option>Corporate Law</option>
                    <option>Family Law</option>
                    <option>Criminal Defence</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Describe the matter<span className="required">*</span></label>
                <textarea placeholder="Brief description of legal matter" rows="4" required></textarea>
              </div>

              <div className="form-submit">
                <button type="submit" className="btn-gold-outline">Book A Consultation</button>
                <p className="privacy-text">
                  By submitting this form, you agree to our privacy policy. All information provided is confidential.
                </p>
              </div>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Consultation;